import React from "react"
import { User } from "firebase/auth"
import { LiveId, SelectionId, SelectionParticipantId, SelectionSequenceId, SpaceKey } from "popopo-msg"
import { Button } from "react-bootstrap"
import { useForm } from "react-hook-form"
import { api } from "../../core"

export const SelectionNominateSelectButton = (props: {
  firebase: User
  spaceKey: SpaceKey
  liveId: LiveId
  selectionId: SelectionId
  latestSequence: SelectionSequenceId | null,
  participantId: SelectionParticipantId,
}) => {
  const form = useForm({
    mode: "onBlur",
  })

  const { spaceKey, liveId, selectionId, participantId } = props

  const onClick = async (selected: boolean) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST(`/api/v2/spaces/{space_key}/lives/{live_id}/selections/{selection_id}/sequences/update-selected-participant`, {
        params: {
          path: {
            space_key: spaceKey,
            live_id: liveId,
            selection_id: selectionId,
          },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: {
          selected,
          participantId,
          sequence: {
            id: props.latestSequence ?? "",
          },
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <Button variant={"warning"} onClick={form.handleSubmit(() => onClick(true))}>
        Select
      </Button>
      <Button variant={"warning"} onClick={form.handleSubmit(() => onClick(false))}>
        Un-select
      </Button>
    </>
  )
}
